import React, { FC } from 'react';
import cn from 'classnames';

export const TicketHeader: FC = ({ children }) => (
  <div className={cn('font-semi-bold-base', 'px-4', 'py-3', 'border-bottom')}>
    <div className={cn('align-items-center', 'd-flex')}>{children}</div>
  </div>
);
